import _ from 'lodash'
import Api from '../Util/API';
import Auth from '../Auth/Auth';
import moment from 'moment';

const auth = new Auth();

export default (dispatcher, events) => {

	let state = {
		projects: [],
		emptyProjects: false,
		emptyPrivateProjects: false,
		allprojects: [],
		currentProject:[],
		loggedIn: false,
		currentUser: {},
		currentRoute: 'Explore',
		currentUserProjects: [],
		currentUserBackedProjects: [],
		currentUserProjectInvitations: [],
		currentUserProjectsNotSeen: [],
		isModalVisible: false,
		modalVisible:'',
		formRedirect: false,
		deleteRedirect: false,
		users: [],
		usersList:[],
		usersMailingList:[],
		usersListFiltered:[],
		mailingList: [],
		transactions: [],
		backingIsLoading:false,
		inviteBackersIsLoading:false,
		deleteProjectIsLoading:false,
		achieveProjectIsLoading:false,
		answerIsLoading:false,
		alertVisible:false,
		alertMessage:'',
		isAdmin:false,
		wallets:[],
		connexionUri: '',
		hasRefreshed:false,
		refreshProject:false
	}

	function getState() {
		return state;
	}

	function refresh(s) {
		state = s;
		dispatcher.emit(events.REFRESH, state);
	}

	function formatUsersList(payload){
		if(state.usersList.length === 0){
			for(let i=0;i < payload.length;i++){
				if(payload[i].name !== null){
					state.usersList.push({'label':payload[i].name,'value':payload[i].id,'email':payload[i].email})
				}
			}
		}
	}

	function formatUsersMailingList(payload){
		for(let i=0;i < payload.length;i++){
			if(payload[i].name !== null){
				state.usersMailingList.push({'email':payload[i].email,'id':payload[i].id})
			}
		}
	}

	function checkAdmin(email){
		if(process.env.REACT_APP_BACKON_ADMIN.indexOf(email) !== -1){
			state.isAdmin = true;
		}
	}

	dispatcher.on(events.GET_PROFILE, () => {
		let profile = auth.getProfile();
		if(profile !== null){
			state.currentUser.name = profile.name;
			state.currentUser.avatar = profile.picture;
			state.currentUser.email = profile.email;
			state.loggedIn = true;
			checkAdmin(profile.email);
			refresh(state);
			dispatcher.emit(events.GET_WALLET);
		}
	});

	dispatcher.on(events.STOCK_CONNEXION_URI, url => {
		let path = url.replace(process.env.REACT_APP_BACKON_APP + '/','');
		state.connexionUri = path;
		if(path === undefined || path === '' || path === 'login'){
			state.connexionUri = '/';
		}
      	let currentStorage = localStorage.getItem('connexionUri');
      	if(currentStorage === null){
      		localStorage.setItem('connexionUri', state.connexionUri);
      	}else{
      		state.connexionUri = currentStorage;
      	}
		refresh(state);
	});

	dispatcher.on(events.CHECK_REDIRECT_VALUE, () => {
      	let currentStorage = localStorage.getItem('connexionUri');
		if(currentStorage === null){
      		state.connexionUri = false;
			refresh(state);
      	}else{
      		state.connexionUri = currentStorage;
			refresh(state);
      	}
	});

	dispatcher.on(events.HAS_BEEN_REDIRECT, () => {
  		localStorage.removeItem('connexionUri');
  		state.connexionUri = false;
		refresh(state);
	});

	dispatcher.on(events.GET_PROJECTS, () => {
		Api.request('projects/' + state.currentUser.email)
			.then(projects => {
				dispatcher.emit(events.GET_NOTIFICATIONS);
				//Order projects by ending date
				let projectsOrderedByDate = _.sortBy(projects,function(node){
				  return - (new Date(node.project_end_at).getTime());
				});
				//Remove projects achieved more than a month ago
				let dateMonthAgo = moment().subtract(30, 'days').format();
				state.projects = _.reject(projectsOrderedByDate, function(item){ return item.project_achieved_at < dateMonthAgo; });
				//reject private projects
				state.projects = _.reject(state.projects, {privacy: 1}).reverse();
				//Handle the case where no projects have been created
				if(state.projects.length === 0){
					state.emptyProjects = true;
				}else{
					state.emptyProjects = false;
				}
				state.formRedirect = false;
				dispatcher.emit(events.REFRESH_PROJECTS);
				refresh(state);
			});
	});

	dispatcher.on(events.REFRESH_PROJECTS, () => {
		if(state.hasRefreshed !== true){
			setTimeout(function(){ 
				state.hasRefreshed = true;
				refresh(state);
			}, 1000);
		}
	});

	dispatcher.on(events.GET_ALL_PROJECTS, () => {
		Api.request('projects/' + state.currentUser.email)
			.then(projects => {
				state.allprojects = _.sortBy(projects, 'project_end_at');
				refresh(state);
			});
	});

	dispatcher.on(events.GET_NOTIFICATIONS, () => {
    	let profile = JSON.parse(localStorage.getItem('profile'));
		state.currentUser.email = profile.email;
		state.currentUser.name = profile.name;
		state.currentUser.avatar = profile.picture;
		Api.request('projects/private/' + state.currentUser.email)
			.then(projects => {
				dispatcher.emit(events.CHECK_FOR_NOTIFICATIONS, projects);
			});
	});

	dispatcher.on(events.CHECK_FOR_NOTIFICATIONS, payload => {
		//FILTRE LES PROJETS PAS CREES PAR LE USER SUR LESQUEL IL A ETE INVITE
		let payloadFiltered = _.reject(payload, {creator_email : state.currentUser.email});
		let payloadFilteredHasNotSeenInvite = _.filter(payloadFiltered, {has_seen_invite : 0});
		state.currentUserProjectsNotSeen = payloadFilteredHasNotSeenInvite;
		refresh(state);
	});

	dispatcher.on(events.GET_USERS_LIST, () => {
		Api.request('users')
			.then(users => {
				if(users.length > 0){
					formatUsersList(users);
					formatUsersMailingList(users);
					let currentUser = _.filter(state.usersList, {email : state.currentUser.email});
					state.currentUser.id = currentUser.id;
					refresh(state);
				}
			});
	});

	dispatcher.on(events.GET_CURRENT_PROJECT, id => {
		Api.request('projects/' + state.currentUser.email)
			.then(projects => {
				let currentProject = _.filter(projects, {project_id: id});
				state.currentProject = currentProject[0];
				refresh(state);
			});
	});

	dispatcher.on(events.GET_PERSONNAL_PROJECTS, () => {
		Api.request('projects/' + state.currentUser.email)
			.then(projects => {
				let projectsOrderedByDate = _.sortBy(projects,function(node){
				  return - (new Date(node.project_end_at).getTime());
				});
				state.projects = _.reject(projectsOrderedByDate, {privacy: 1}).reverse();
				dispatcher.emit(events.FILTER_PERSONNAL_PROJECTS, projects);
				//dispatcher.emit(events.FILTER_BACKED_PROJECTS);
				refresh(state);
			})
		    .catch(error => {
		        console.log(error);
		    });
	});

	dispatcher.on(events.FILTER_PERSONNAL_PROJECTS, payload => {
		//FILTRE LES PROJETS CREES PAR LE USER
		let currentUserProjects = _.filter(payload, {creator_email : state.currentUser.email});
		state.currentUserProjects = currentUserProjects;
		if(currentUserProjects.length === 0){
			state.emptyPrivateProjects = true;
		}else{
			state.emptyPrivateProjects = false;
		}
		refresh(state);

		Api.request('projects/private/' + state.currentUser.email)
			.then(projects => {
				dispatcher.emit(events.FILTER_INVITATIONS, projects);
			});
	});

	dispatcher.on(events.FILTER_INVITATIONS, payload => {
		//ON ENLEVE LES PROJETS PERSOS
		let filteredPayload = _.reject(payload, {creator_email : state.currentUser.email});
		//ON ENLEVE CEUX DONT ON A REFUSE L INVIT
		filteredPayload = _.reject(filteredPayload, {has_accepted_invite : 2});
		//FILTEREDPAYLOAD CONTIENT DONC LES PROJETS SUR LESQUELS ON A ETE INVITE QU'ON A REJOINT OU PAS ENCORE REJOINT

		Api.request('projects/backed/' + state.currentUser.email)
			.then(projects => {
				//ON ENLEVE LES PROJETS PERSOS DES PROJETS BACKES
				state.currentUserBackedProjects = _.reject(projects, {creator_email : state.currentUser.email});
				//ON ENLEVE CEUX SUR LESQUELS ON A BACKE
				let inviteArray = [];
				let backedArray = [];
				for(let i = 0; i < filteredPayload.length; i++){
					inviteArray.push(filteredPayload[i].project_id);
				}
				for(let i = 0; i < projects.length; i++){
					backedArray.push(projects[i].project_id);
				}
				let diffArray = _.difference(inviteArray, backedArray);
				state.currentUserProjectInvitations = [];
				for(let i = 0; i < diffArray.length; i++){
					let currentProject = _.filter(filteredPayload, {project_id : diffArray[i]});
					state.currentUserProjectInvitations = state.currentUserProjectInvitations.concat(currentProject);
				}
				state.currentUserProjectInvitations = _.uniq(state.currentUserProjectInvitations);
				state.currentUserProjectInvitations = _.reject(state.currentUserProjectInvitations, function(project) { return project.project_achieved_at !== null; });
				refresh(state);
			});
	});

	dispatcher.on(events.GET_WALLET, () => {
		//GET THE WALLET OF THE CURRENT USER USING HIS EMAIL
		Api.request('wallets/' + state.currentUser.email)
			.then(wallet => {
				if(wallet.length > 0){
					state.currentUser.wallet = wallet[0].wallet;
					refresh(state);
				}
			});
	});

	dispatcher.on(events.SET_CURRENT_ROUTE, value => {
		state.currentRoute = value;
		refresh(state);
	});

	dispatcher.on(events.DISPLAY_MODAL, value => {
		state.isModalVisible = true;
		state.modalVisible = value;
		refresh(state);
	});

	dispatcher.on(events.HIDE_MODAL, () => {
		state.isModalVisible = false;
		refresh(state);
	});

	dispatcher.on(events.POST_PROJECT, data => {
		state.formRedirect = true;
		refresh(state);
		Api.request('mailer/create', 'POST', {data})
					.then((result) => {
		        		//console.log('mail envoyé');
					});
        dispatcher.emit(events.GET_PROJECTS);
        
	});

	dispatcher.on(events.EDIT_PROJECT, data => {
        state.formRedirect = true;
		refresh(state);
		Api.request('mailer/edit', 'POST', {data})
					.then((result) => {
		        		//console.log('mail envoyé');
					});
        dispatcher.emit(events.GET_PROJECTS);
	});

	dispatcher.on(events.POST_TRANSACTION, (project_id,amount,title) => {
		state.backingIsLoading = true;
		refresh(state);

		let currentDate = moment().format('MMMM Do YYYY, h:mm:ss a');

		let data = {
			'user_email':state.currentUser.email,
			'name':state.currentUser.name,
			'project_id':project_id,
			'title':title,
			'amount':amount,
			'date':currentDate
		}

		Api.request('transactions', 'POST', {data})
			.then((result) => {
        		dispatcher.emit(events.GET_PROJECTS);
				state.isModalVisible = false;
				state.backingIsLoading = false;
				refresh(state);
			});
			
	});

	dispatcher.on(events.ADD_ALLOWED_BACKERS, (users_id,project_id) => {
		state.inviteBackersIsLoading = true;
		refresh(state);
		let data = {
			'users_id':users_id,
			'project_id':project_id
		}
		Api.request('users/allowed', 'POST', {data})
			.then((result) => {
        		dispatcher.emit(events.GET_PROJECTS);
				state.isModalVisible = false;
        		state.inviteBackersIsLoading = false;
				refresh(state);
			});
	});

	dispatcher.on(events.POST_INVITE_SEEN, project_id => {
		let data = {
			'user_id':state.currentUser.email,
			'project_id':project_id
		}
		Api.request('users/invite/seen', 'POST', {data})
			.then((result) => {
				dispatcher.emit(events.GET_NOTIFICATIONS);
			});
	});

	dispatcher.on(events.ANSWER_INVITE, (project_id,value) => {
		state.answerIsLoading = true;
		let data = {
			'user_id':state.currentUser.email,
			'project_id':project_id,
			'value':value
		}
		Api.request('users/invite/answered', 'POST', {data})
			.then((result) => {
				dispatcher.emit(events.GET_PERSONNAL_PROJECTS);
				state.answerIsLoading = false;
				let data = {
					'user_id':state.currentUser.email,
					'project_id':project_id
				}
				Api.request('users/invite/seen', 'POST', {data})
					.then((result) => {
						dispatcher.emit(events.GET_NOTIFICATIONS);
					});
			});

	});

	dispatcher.on(events.DELETE_PROJECT, data => {
		state.deleteProjectIsLoading = true;
		refresh(state);
		Api.request('projects/' + data.project_id, 'DELETE')
			.then((result) => {
				Api.request('mailer/delete', 'POST', {data})
					.then((result) => {
		        		console.log('mail envoyé');
					});
        		dispatcher.emit(events.GET_PROJECTS);
				state.isModalVisible = false;
				state.deleteProjectIsLoading = false;
				state.deleteRedirect = true;
				refresh(state);
			});
	});
	
	dispatcher.on(events.INVITE_BACKERS_BY_EMAIL, (project,users) => {
		let mailingList = [];
		let usersTab = users.split(',');
		for(let i=0; i < usersTab.length; i++){
			let currentUser = _.filter(state.usersList, {value : parseInt(usersTab[i], 10)});
			if(currentUser.length > 0){
				mailingList = mailingList.concat(currentUser[0].email);
			}
		}
		let data = {
			'project':project,
			'users':mailingList
		}
		Api.request('mailer/invite', 'POST', {data})
			.then((result) => {
        		//console.log('mail envoyé')
			});
	});

	dispatcher.on(events.FILTER_BACKERS_INVITE, (payload) => {
		Api.request('users')
			.then(users => {
				formatUsersList(users);
			})
			.then(users => {
				state.usersListFiltered = _.sortBy(state.usersList, 'label');
				state.usersListFiltered = _.reject(state.usersListFiltered, {email: state.currentUser.email});
				for(let i = 0; i < payload.length; i++){
					state.usersListFiltered = _.reject(state.usersListFiltered, {email: payload[i].email});
				}
				refresh(state);
			});
		
	});

	dispatcher.on(events.ACHIEVE_PROJECT, data => {
		state.achieveProjectIsLoading = true;
		refresh(state);
		Api.request('projects/achieve/' + data.project_id, 'POST')
			.then((result) => {
				state.achieveProjectIsLoading = false;
        		dispatcher.emit(events.GET_PROJECTS);
				refresh(state);
			});
		Api.request('mailer/achieve', 'POST', {data})
			.then((result) => {
        		//console.log('mail envoyé')
			});
	});

	dispatcher.on(events.ACHIEVE_PROJECT_EMAIL, project => {
		Api.request('mailer/achieve', 'POST', {project})
			.then((result) => {
        		//console.log('mail envoyé')
			});
	});

	dispatcher.on(events.MOVE_PROJECT_TO_CURRENT_YEAR, data => {
		Api.request('projects/update/' + data.project_id, 'POST', {data})
			.then((result) => {
        		state.refreshProject = true;
        		dispatcher.emit(events.GET_PROJECTS);
				refresh(state);
			});
		state.refreshProject = false;
	});

	dispatcher.on(events.SEND_BILL_TO_OM, data => {
		Api.request('mailer/achieve/bill', 'POST', {data})
			.then((result) => {
				state.formRedirect = true;
				refresh(state);
        		//console.log('mail envoyé')
			});
	});

	dispatcher.on(events.GET_ALL_TRANSACTIONS, () => {
		Api.request('transactions')
			.then(transactions => {
				let transactionsOrderedByDate = _.sortBy(transactions, 'created_at');
				transactionsOrderedByDate.reverse();
				state.transactions = transactionsOrderedByDate;
				refresh(state);
			});
	});

	dispatcher.on(events.GET_ALL_WALLETS, () => {
		Api.request('wallets/all')
			.then(wallets => {
				state.wallets = wallets;
				refresh(state);
			});
	});
	
	return {
		getState
	};
};



// WEBPACK FOOTER //
// ./src/Store/index.js